import { IoEyeOffOutline, IoEyeOutline, IoSearchSharp } from "react-icons/io5";
import { useState, useRef, useEffect } from "react";
import classes from "./InputField.module.css";

const InputField = ({
  labelText,
  className = "",
  labelStyle,
  type = "text",
  placeholder,
  showEye,
  search,
  onChange,
  required,
  value,
  options = [], // Array of { value, label }
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const isSelect = options && options.length > 0;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel = options.find((opt) => opt.value === value)?.label || "";

  return (
    <div className={`${classes.wrapper} ${className}`}>
      {labelText && <label style={labelStyle}>{labelText}</label>}

      <div className={`${classes.inputContainer} d-flex align-items-center gap-2`} ref={dropdownRef}>
        {search && <IoSearchSharp size={20} color="#737373" />}

        {isSelect ? (
          <div className={`${classes.selectBox}`} onClick={() => setShowDropdown(!showDropdown)}>
            <div className={classes.selectValue}>
              {selectedLabel || "Select..."}
            </div>
            {showDropdown && (
              <div className={classes.dropdown}>
                {options.map((opt, idx) => (
                  <div
                    key={idx}
                    className={classes.dropdownItem}
                    onClick={() => {
                      onChange({ target: { value: opt.value } });
                      setShowDropdown(false);
                    }}
                  >
                    {opt.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <input
            type={showPassword ? "text" : type}
            placeholder={placeholder}
            onChange={onChange}
            value={value}
            required={required}
          />
        )}

        {showEye && type === "password" && !isSelect && (
          showPassword ? (
            <IoEyeOutline
              size={24}
              color="#737373"
              role="button"
              onClick={() => setShowPassword(false)}
            />
          ) : (
            <IoEyeOffOutline
              size={24}
              color="#737373"
              role="button"
              onClick={() => setShowPassword(true)}
            />
          )
        )}
      </div>
    </div>
  );
};

export default InputField;